import '@/src/styles/global.css';
import '@ovotech/element-v4/theme.css';
import '@ovotech/element-v5/reset.css';
import '@ovotech/element-v5/theme.css';
import WrappedApp from './WrappedApp';
import { run } from './entry';

run(WrappedApp);
